/**
 * Finds standalone Celsius temperatures and appends Fahrenheit in parentheses.
 * Skips temperatures that already have a parenthetical conversion.
 *
 * Examples:
 *   "37°C"           → "37°C (98.6°F)"
 *   "37 °C"          → "37 °C (98.6°F)"
 *   "37°C (98.6°F)"  → unchanged (already has conversion)
 */
export function addFahrenheit(text: string): string {
  // Match number followed by °C (with optional space), NOT already followed by parenthesized °F
  return text.replace(
    /(-?\d+(?:\.\d+)?)\s?°C(?!\s*\([\d.]+°F\))/g,
    (match, celsius) => {
      const c = parseFloat(celsius);
      const f = (c * 9) / 5 + 32;
      const fStr = Number.isInteger(f) ? f.toString() : f.toFixed(1);
      return `${match} (${fStr}°F)`;
    },
  );
}
